import React from 'react';
import PropTypes from 'prop-types';
import I18n from '../i18n';
import Tooltip from '../tooltip';
import Button from '../button';
import {areArrays, areArraysEqual} from '../../utils/array-equality';

function areValuesEqual(value1, value2) {
  if (areArrays(value1, value2)) {
    return areArraysEqual(value1, value2);
  }
  return value1 === value2;
}

export default function FieldChangedIndicator(props) {
  const {name, originalValue, value, onRevert} = props;

  const onClick = React.useCallback(() => {
    if (onRevert) {
      onRevert(name, originalValue);
    }
  }, [name, originalValue, onRevert]);

  if (areValuesEqual(value, originalValue)) {
    return null;
  } else {
    return (
      <Tooltip
        placement="right"
        message={
          <span>
            <I18n t="field-changed" />
          </span>
        }
      >
        <Button className="field-changed-indicator" icon="undo" onClick={onClick}></Button>
      </Tooltip>
    );
  }
}

FieldChangedIndicator.defaultProps = {};

FieldChangedIndicator.propTypes = {
  /** The name of the field. Should be the name of the HTML form element. */
  name: PropTypes.string.isRequired,
  /** The original value. Passed to the onRevert handler when this component is clicked. */
  originalValue: PropTypes.any,
  /** The current value. */
  value: PropTypes.any,
  /** A callback to execute when this compoennt is clicked. Parameters will be (name, originalValue) */
  onRevert: PropTypes.func.isRequired,
};
